import React from 'react';

import { useStyles } from './NeoAnalyticsSideBar.styles';
import { useTheme } from '@mui/material/styles';
import { ThemeProps } from '@styles/theme';

import { ExecutionsSideBar } from '../ExecutionsSideBar';

import { useExecutionsUIStore } from '@core/useStores';
import { Observer } from 'mobx-react';
import { ExecutionSideBar } from '../ExecutionSideBar';

type SidebarProps = {
    fromGroup?: boolean;
    mode?: 'user' | 'procedure';
    procedureName?: string | null;
    onBack?: () => void;
    onInsights?: () => void;
    procedureImage?: string | null;
}

export const NeoAnalyticsSideBar: React.FC<SidebarProps> = ({
    fromGroup = false,
    mode = 'user',
    procedureName = null,
    onBack,
    onInsights,
    procedureImage = null,
}) =>{
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    const executionsUIStore = useExecutionsUIStore();

    return (
        <>
            <Observer>
                {() => {
                    return (
                        <div className={styles.sideBarWrapper}>
                            <ExecutionsSideBar fromGroup={fromGroup} mode={mode} procedureName={procedureName} procedureImage={procedureImage} onBack={onBack} onInsights={onInsights}/>
                            {executionsUIStore.selectedExecutionId &&
                                <ExecutionSideBar />
                            }
                        </div>
                    )
                }}
            </Observer>
        </>
    )
}